import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminExportCustomsError = () => {
  return useMutation({
    mutationFn: async (ids: string[]) => {
      const response = await apiClient.customsError.exportCustomsErrors.mutation({ body: { ids }, responseType: 'blob' });

      return { data: response };
    },
    onSuccess: ({ data }) => {
      const url = window.URL.createObjectURL(new Blob([data.body as BlobPart], { type: 'application/json' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `customs-errors-export.json`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success('Customs errors export downloaded successfully');
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error exporting customs errors');
    },
  });
};
